import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { localUserService } from "utils/localStorage";
import { DISPATCHER, DRIVER, MANAGER, SUPERADMIN, SUPERVISOR } from "constants/constants";
import AuthPage from "pages/VisitPage/AuthPage";
import Dashboard from "pages/Dashboard/Dashboard";
import Account from "pages/Account/Account";
import AmazonImport from "pages/Import/AmazonImport";
import ShiftReportListPage from "pages/ShiftReports/ShiftReportListPage";
import Scorecard from "pages/Scorecard/Scorecard";
import RouteWithBars from "./components/RouteWithBars";
import ShiftRecordPage from "pages/ShiftReports/ShiftRecordPage";
import CheckPage from "pages/Check/CheckPage";
import CheckWeekPage from "pages/Check/CheckWeekPage";
import ActPage from "pages/Act/ActPage";
import IkeaCheckIkeaPage from "pages/IkeaCheck/IkeaCheckPage";
// import IkeaCheckIkeaWeekPage from "pages/IkeaCheck/IkeaCheckWeekPage";
// import IkeaActPage from "pages/IkeaAct/IkeaActPage";
import AmznScoreboardPage from "pages/AmznScoreboard/AmznScoreboardPage";
// import CustomGraphsPage from "pages/CustomGraphs/CustomGrahpsPage";
import PerformancePage from "pages/Performance/PerformancePage";
import FalconPage from "pages/Falcon/FalconPage";
import SettingsPage from "pages/Settigns/SettingsPage";
import DaStatusPage from "pages/DaAndFleets/DaStatusPage";
import FleetStatusPage from "pages/DaAndFleets/FleetStatusPage";
import SchedulePage from "pages/Schedule/SchedulePage";
import TrackerPage from "pages/Tracker/TrackerPage";
import PayrollPage from "pages/Payroll/PayrollPage";
import FleetReportsPage from "pages/FleetReports/FleetReports";
import DaHomePage from "pages/DaHome/DaHomePage";
import DaFeedbackPage from "pages/DaFeedback/DaFeedbackPage";
import DaFeedbackReport from "pages/DaFeedback/DaFeedbackReportPage";
import ResetPasswordPage from "pages/VisitPage/ResetPage";
import { useTypeSelectors } from "hooks/useTypeSelectors";
// import PrimeSchedulePage from "pages/PrimeSchedule/PrimeSchedulePage";

const Router = () => {
  const token = localUserService.getAccess();
  const permissionKey = localUserService.getPermissions();
  const permissionKeyNumber = permissionKey ? permissionKey : 1;
  const { isLoginError } = useTypeSelectors((state) => state.auth);

  return (
    <BrowserRouter>
      <Toaster />
      <Switch>
        <Route exact path="/">
          {token && permissionKey && !isLoginError ? (
            permissionKey !== DISPATCHER && permissionKey !== DRIVER ? (
              <Redirect to="/dashboard" />
            ) : permissionKey === DRIVER ? (
              <Redirect to="/da-action" />
            ) : (
              <Redirect to="/das-reports" />
            )
          ) : (
            <AuthPage />
          )}
        </Route>
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/account"
          component={Account}
        />
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/dashboard"
          component={Dashboard}
        />
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/das-reports"
          component={ShiftReportListPage}
        />
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/das-reports/:id"
          component={ShiftRecordPage}
        />
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/import"
          component={AmazonImport}
        />
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[SUPERADMIN, MANAGER, SUPERVISOR]}
          path="/scorecard"
          component={Scorecard}
        />
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/amzn-scoreboard"
          component={AmznScoreboardPage}
        />
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/check"
          component={CheckPage}
        />
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/check/:id"
          component={CheckWeekPage}
        />
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/act"
          component={ActPage}
        />
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/check-ikea"
          component={IkeaCheckIkeaPage}
        />
        {/* <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/check-ikea/:id"
          component={IkeaCheckIkeaWeekPage}
        />
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/act-ikea"
          component={IkeaActPage}
        /> */}
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/performance"
          component={PerformancePage}
        />
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[SUPERADMIN, SUPERVISOR, MANAGER]}
          path="/falcon"
          component={FalconPage}
        />
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[SUPERVISOR, MANAGER, SUPERADMIN, DISPATCHER, DRIVER]}
          path="/settings"
          component={SettingsPage}
        />
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[SUPERVISOR, DISPATCHER, MANAGER, SUPERADMIN]}
          path="/da-status"
          component={DaStatusPage}
        />
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[SUPERVISOR, DISPATCHER, MANAGER, SUPERADMIN]}
          path="/fleet-status"
          component={FleetStatusPage}
        />
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/schedule"
          component={SchedulePage}
        />
        {/* <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN]}
          path="/prime-schedule"
          component={PrimeSchedulePage}
        /> */}
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[SUPERVISOR, SUPERADMIN, MANAGER]}
          path="/tracker"
          component={TrackerPage}
        />
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[SUPERADMIN]}
          path="/payroll"
          component={PayrollPage}
        />
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[SUPERADMIN]}
          path="/fleet-reports"
          component={FleetReportsPage}
        />
        {/* <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[SUPERADMIN]}
          path="/graphs"
          component={CustomGraphsPage}
        /> */}
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[DRIVER]}
          path="/da-home"
          component={DaHomePage}
        />
        <RouteWithBars
          exact
          permission={permissionKeyNumber}
          permissionKey={[DRIVER]}
          path="/da-action"
          component={DaFeedbackPage}
        />
        <RouteWithBars
          permission={permissionKeyNumber}
          permissionKey={[DRIVER]}
          path="/da-action/:id"
          component={DaFeedbackReport}
        />
        <Route exact path="/password-reset/">
          <ResetPasswordPage />
        </Route>
        <Route path="/*/">
          <>Not Found</>
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
